
import type { PropType } from 'vue'
import { defineComponent } from 'vue'

// > services/types <
import { WaybillType } from '@/modern/modules/m-dispatcher-module/services/types/waybill.types'

export default defineComponent({
    props: {
        type: {
            type: [String, null] as PropType<WaybillType>,
            default: null
        },
    },
})
